import type { BrowserTitleStatus } from '@puffin/app-frame-api';
import type { AnyRouter } from '@tanstack/react-router';
import { create } from 'zustand';

const statusPrefixes: Record<BrowserTitleStatus, string | undefined> = { running: '⏱️', completed: '✅', failed: '❌', none: undefined };
interface BrowserTitleState {
  status: BrowserTitleStatus;
  updateStatus: (status: BrowserTitleStatus) => void;
}

const useBrowserTitleStore = create<BrowserTitleState>((set) => ({
  status: 'none',
  updateStatus: (status) => set({ status }),
}));

export const getDocumentTitlePrefix = (): string | undefined => statusPrefixes[useBrowserTitleStore.getState().status];

export const useDocumentTitlePrefix = () => useBrowserTitleStore((state) => statusPrefixes[state.status]);

export const updateBrowserTitleStatus = (status: BrowserTitleStatus): void => useBrowserTitleStore.getState().updateStatus(status);

export const resetBrowserTitleStatusOnNavigation = (router: AnyRouter) =>
  router.subscribe('onBeforeNavigate', ({ pathChanged }) => {
    if (pathChanged) {
      updateBrowserTitleStatus('none');
    }
  });
